/* eslint-disable @typescript-eslint/no-explicit-any */
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Card, Image, Popover, Tag } from "antd";
import { useState } from "react";
import PopOverCard from "./PopOverCard";
import { formatEstimatedHrs } from "../../../../config/utils";

function TaskCard(props: any) {
  const {
    task,
    isLastIndex,
    selectedDate,
    isFirstIndex,
    crewId,
    setLoading,
    loading,
    oldDate,
  } = props;
  const [open, setOpen] = useState(false);

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const {
    setNodeRef,
    attributes,
    listeners,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: task.id,
    data: {
      type: "Task",
      task,
    },
  });

  const style = {
    transition,
    transform: CSS.Transform.toString(transform),
  };

  if (isDragging) {
    return (
      <div
        className="role_wrapper is_dragging"
        ref={setNodeRef}
        style={style}
      />
    );
  }

  // console.log("task", task);

  let cardClass = "crewListCard";
  if (task?.status === "COMPLETED") {
    cardClass += " completed";
  } else if (task?.status === "CONFIRMATION_PENDING") {
    cardClass += " confirmation_pending";
  } else if (task?.status === "IN_PROGRESS") {
    cardClass += " in_progress";
  } else if (task?.status === "SCHEDULED") {
    cardClass += " scheduled";
  } else if (task?.status === "UNPUBLISHED") {
    cardClass += " unpublished";
  } else if (task?.status === "MISSED") {
    cardClass += " missed";
  } else if (task?.status === "REACHED") {
    cardClass += " reached";
  }
  const isToday = selectedDate
    ? new Date(selectedDate).toDateString() === new Date().toDateString()
    : false;
  return (
    <div ref={setNodeRef} style={style} className="role_wrapper">
      {isFirstIndex || isLastIndex ? (
        <Card
          className={
            isLastIndex && isToday
              ? "crewListCard scheduled"
              : `crewListCard ${cardClass}`
          }
          {...listeners}
          {...attributes}
        >
          <div className="taskTitle">
            {isFirstIndex && (
              <Image src="/images/schedule/icon-home.svg" preview={false} />
            )}
            {isLastIndex && (
              <Image
                src="/images/schedule/icon-crew-yard.svg"
                preview={false}
              />
            )}{" "}
            <span>{task?.title}</span>
          </div>
          {/* <Tag>
            <Image
              src="/images/schedule/clock-icon.svg"
              preview={false}
              style={{ width: "14px" }}
            />
            {formatEstimatedHrs(task?.duration)}
          </Tag> */}
        </Card>
      ) : (
        <Popover
          title={
            <PopOverCard
              visitData={task}
              crewId={crewId}
              companyId={task?.company_id}
              setLoading={setLoading}
              loading={loading}
              oldDate={oldDate}
              selectedDate={selectedDate}
            />
          }
          trigger="click"
          open={open}
          onOpenChange={handleOpenChange}
          placement="right"
          arrow={false}
        >
          <Card className={cardClass} {...listeners} {...attributes}>
            <div className="taskTitle">
              <span>{task?.title}</span>
            </div>
            <Tag>
              <Image
                src="/images/schedule/clock-icon.svg"
                preview={false}
                style={{ width: "14px" }}
              />
              {formatEstimatedHrs(task?.duration)}
            </Tag>
          </Card>
        </Popover>
      )}

      {/* <button onClick={() => deleteTask(task.id)}>Delete</button> */}
    </div>
  );
}

export default TaskCard;
